import { render, staticRenderFns } from "./ComponentMedicalDetail.vue?vue&type=template&id=06033761&"
import script from "./ComponentMedicalDetail.vue?vue&type=script&lang=js&"
export * from "./ComponentMedicalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports